/** @file Export result: error/ok line, translated errors, warnings, sprite scale and download links. */
import type { ExportResult } from '@pose2d/api/export/exportTypes';
import type { Translate } from '@pose2d/i18n/types';
import { errorText } from '../../shell/i18n/errorText';

/** Report errors render like any Pose2DError (errorText); warnings show their English message and path. */
export function ExportReport({ t, result }: { t: Translate; result: ExportResult }) {
  const { errors, warnings } = result.report;
  return (
    <div className="export-report" data-testid="export-report">
      <p className={errors.length === 0 ? 'export-ok' : 'shell-error'}>{errors.length === 0 ? t('exportDialog.ok') : t('exportDialog.failed', { n: errors.length })}</p>
      {errors.map((e, i) => <p key={`e${String(i)}`} className="shell-error">{errorText(t, { pose2d: e })}</p>)}
      {warnings.length === 0 ? null : (
        <details><summary>{t('exportDialog.warnings', { n: warnings.length })}</summary>
          <ul>{warnings.map((w, i) => <li key={`w${String(i)}`}>{t('exportDialog.warning', { code: w.code, message: w.message, path: w.path ?? '' })}</li>)}</ul>
        </details>
      )}
      {result.scale === undefined ? null : <p>{t('exportDialog.scaleUsed', { scale: result.scale })}</p>}
      <h3>{t('exportDialog.files')}</h3>
      <ul>{result.files.map((f) => <li key={f.url}><a href={f.url} download={f.name}>{f.name}</a></li>)}</ul>
    </div>
  );
}
